import React, { useState, useEffect } from 'react';
import { FaChevronUp } from 'react-icons/fa';

interface Props {
  mainRef: React.RefObject<HTMLElement>;
}

export const ButtonScrollTop = (props: Props) => {
  const { mainRef } = props;
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (mainRef.current) {
      const scrollTop = mainRef.current.scrollTop;
      if (scrollTop > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }
  };

  const scrollToTop = () => {
    if (mainRef.current) {
      mainRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.addEventListener('scroll', toggleVisibility);

      return () => {
        if (mainRef.current) {
          mainRef.current.removeEventListener('scroll', toggleVisibility);
        }
      };
    }
  }, [mainRef]);

  return (
    <button
      onClick={scrollToTop}
      className="z-50 p-2 md:p-3 bg-gray-400 text-white rounded-full"
      style={{ display: isVisible ? 'block' : 'none' }}
      aria-label="Scroll to top"
    >
      <FaChevronUp />
    </button>
  );
};
